import { useState } from 'react';
import { Download } from 'lucide-react';
import { usePwaInstall } from './usePwaInstall';
import IosHintModal from './IosHintModal';

/**
 * Przycisk „Zainstaluj aplikację" (PWA) do stopki sidebara StudioShell.
 * Ukryty gdy aplikacja już zainstalowana lub niedostępna do instalacji.
 */
export default function InstallPWA() {
  const { available, installed, promptInstall } = usePwaInstall();
  const [iosHint, setIosHint] = useState(false);

  if (installed || !available) return null;

  const handleInstall = async () => {
    const r = await promptInstall();
    if (r === 'ios') setIosHint(true);
  };

  return (
    <>
      <button
        onClick={handleInstall}
        data-testid="install-pwa-btn"
        className="w-full flex items-center gap-2 px-2.5 py-2 rounded-lg text-left hover:bg-[var(--shell-sidebar-hover)] transition-colors"
      >
        <Download className="w-3.5 h-3.5 flex-shrink-0" style={{ color: 'var(--breed-accent, var(--apisai-primary))' }} />
        <span className="text-white/70 text-[11px] font-semibold">Zainstaluj aplikację</span>
      </button>
      {iosHint && <IosHintModal onClose={() => setIosHint(false)} />}
    </>
  );
}
